<template>
  <div class="filter-container">
    <el-form
      ref="searchForm"
      :model="searchForm"
      :inline="true"
      label-width="100px"
    >
      <el-form-item label="索赔结算单号">
        <el-input
          v-model="searchForm.settlementId"
          placeholder="请输入索赔结算单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="结算单状态">
        <el-select
          filterable
          clearable
          v-model="searchForm.settlementStatus"
          placeholder="请选择结算单状态"
        >
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="国家">
        <el-select
          filterable
          clearable
          v-model="searchForm.customerCountry"
          placeholder="请选择国家"
        >
          <el-option
            v-for="item in nationList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="结算时间">
        <el-date-picker
          v-model="settlementTime"
          type="daterange"
          range-separator="-"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结算币种">
        <el-select
          v-model="searchForm.currency"
          placeholder="请选择结算币种"
          filterable
          clearable
        >
          <el-option label="CNY" :value="0"> </el-option>
          <el-option label="USD" :value="1"> </el-option>
        </el-select>
      </el-form-item>

      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button type="primary" plain @click="handleResetQuery">重置</el-button>
    </el-form>
  </div>
</template>
<script>
import { getSession } from "@/util/localStor";
export default {
  props: {
    statusList: {
      type: Array,
      default: () => {},
    },
    settlementStatus: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      searchForm: {
        settlementId: "",
        settlementStatus: this.settlementStatus,
        customerAccountNum: "",
        customerName: "",
        customerCountry: null,
        currency: "",
      },
      settlementTime: [],
      nationList: [],
    };
  },
  mounted() {
    this.nationList = Object.values(getSession("nationList"));
    this.nationList[0].id = "";
  },
  methods: {
    // 搜索
    handleSearch() {
      if (this.settlementTime) {
        this.searchForm.settlementTimeStart = this.settlementTime[0];
        this.searchForm.settlementTimeEnd = this.settlementTime[1];
        this.$emit("handleSearch", this.searchForm);
      } else {
        this.searchForm.settlementTimeStart = "";
        this.searchForm.settlementTimeEnd = "";
        this.$emit("handleSearch", this.searchForm);
      }
    },

    // 重置查询条件
    handleResetQuery() {
      this.searchForm = Object.assign({}, this.$options.data()?.searchForm);
      this.searchForm.settlementStatus = this.settlementStatus;
      this.settlementTime = [];
      this.handleSearch();
    },
  },
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<!-- <style lang="scss" scoped>
.search {
  padding: 0 60px;
  margin-top: 15px;
  border-bottom: 5px solid #efefef;
  padding-right: 60px;
  ::v-deep .el-input {
    width: 200px;
  }
}
</style> -->
